import React, { ForwardedRef, ReactElement, useEffect, useImperativeHandle, useState } from 'react';
import './KodanshaSelect.scss';
import { ReactComponent as MenuArrow } from '../../Assets/icons/MenuArrow.svg';

interface KodanshaSelectProps {
    title: string;
    items: string[] | number[];
    onClicked?: () => any;
    onMainClicked?: () => any;
    onChange?: (event) => void;
    SelectbarAsInput?: boolean;
    disableTextTransform?: boolean;
}

const KodanshaSelect = React.forwardRef(
    (
        {
            title,
            items,
            onClicked,
            onMainClicked,
            onChange,
            SelectbarAsInput = false,
            disableTextTransform = false
        }: KodanshaSelectProps,
        ref: ForwardedRef<HTMLDivElement>
    ): ReactElement => {
    const [active, setActive] = useState(false);
    const [selected, setSelected] = useState(title);
    const [filteredItems, setFilteredItems] = useState(items);
    const overFlowY = React.useRef(0);
    const scrollable = React.useRef(null);
    const firstFocus = React.useRef(true);

    useEffect(() => {
        if (active && scrollable.current) {
            scrollable.current.scrollTo(0, overFlowY.current);
        }
        const close = () => {
            setActive(false);
        };
        if (active) {
            window.addEventListener('click', close);
        }
        return () => window.removeEventListener('click', close);
    }, [active]);

    const onOptionClicked = (e, item) => {
        e.stopPropagation();
        // console.log('scrollable.current.scrollY', scrollable?.current.scrollTop);
        overFlowY.current = scrollable.current.scrollTop;
        setSelected(item);
        setActive(false);
        onChange(item);
        if (typeof onClicked === typeof Function) {
            onClicked();
        }
    };

        useImperativeHandle(ref, () => (({
            changeSelected(selected) {
                setSelected(selected);
            }
        }) as any))


    const onMainSelectClicked = (): void => {
        if (typeof onMainClicked === typeof Function) {
            onMainClicked();
        }
        !SelectbarAsInput && setActive(active => !active);
    };

    const onInputChanged = (event) => {
        setSelected(event.target.value);
        setFilteredItems(() => {
            return (items as string[]).filter((item) => {
                return item.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1;
            });
        });
    };

    // console.log('active', active);

    return (
        <div onClick={(): void => onMainSelectClicked()}
             className='ui-select-container'>
            <div className='ui-select-title-wrapper'>
                {SelectbarAsInput ? <input className='ui-select-title'
                                           style={{ textTransform: (disableTextTransform ? 'none' : 'uppercase') }}
                                           placeholder={selected}
                                           onFocus={() => {
                                               if (firstFocus.current) {
                                                   firstFocus.current = false;
                                                   setSelected('');
                                               }
                                               setActive(true);
                                           }}
                                           value={selected}
                                           aria-label={'input for item search in select bar'}
                                           onChange={onInputChanged} /> :
                    <span className='ui-select-title'
                          style={{ textTransform: (disableTextTransform ? 'none' : 'uppercase') }}>{selected}</span>}
                <MenuArrow width={15} className='ui-select-icon' />
            </div>

            {active &&
                (filteredItems.length > 0 ? <div ref={scrollable} className='ui-select-open-wrapper'>
                    {filteredItems.map(item => {
                        return <div aria-label={'select ' + item} onClick={(e) => onOptionClicked(e, item)} key={item} className='ui-select-item'>
                            {item}
                        </div>;
                    })}
                </div> : <div className='ui-select-open-wrapper'>
                    <div className='ui-select-item'>
                        No items
                    </div>
                </div>)
            }

        </div>
    );
});

export default KodanshaSelect;